module.exports = __webpack_public_path__ + "static/media/dosya_guide.drawio.45864705.svg";